import Debug from 'debug';
import { QuizPlayerStateMachineAbstractState,
         QuizMode, QuizPlayerStateMachineCommonEvents, ChildStateMachine } from './quiz-player-state-machine-state'
import { QuizPlayerStateMachineData } from '../data';
import { PracticeStateMachine } from '@/app/practice-player/domain';
import { PracticeSessionState } from '@/app/practice-session/service';
import { ChildStateMachineHandler } from './child-state-machine-handler'

const debug = Debug('quiz-player-practice-state')

export type QuizPracticeStartOptions = {
  type: 'new'
  sessionId: string
  questionCount: number
} | {
  type: 'continue'
  sessionId: string
  state: PracticeSessionState
}

interface Events extends QuizPlayerStateMachineCommonEvents {
  onTryAgain: (mode: QuizMode) => void
  onContinueError: () => void
}

export class QuizPlayerPracticeState extends QuizPlayerStateMachineAbstractState<Events> {

  public readonly name = 'practice'

  private handler: ChildStateMachineHandler

  constructor(
    private startOptions: QuizPracticeStartOptions,
    private data: QuizPlayerStateMachineData,
    private practiceStateMachine: PracticeStateMachine) {

    super()

    this.handler = new ChildStateMachineHandler('practice', practiceStateMachine, this)
  }

  enter() {
    debug('enter')
    this.data.goToPractice()

    const inputOptions = this.startOptions
    const basic = {
      practiceId: this.data.quizId,
      aspect: this.data.aspect
    }
    const options = {
      ...inputOptions,
      ...basic
    }
    
    this.practiceStateMachine.start(options)
    this.handler.enter()
  }

  exit() {
    debug('exit')
    this.handler.exit()
  }

  cancel() {
    debug('cancel')
    this.beginCancel()
    this.practiceStateMachine.cancel()
  }

  tryAgain(mode: QuizMode) {
    debug('tryAgain', mode)
    this.handler.tryAgain(mode)
  }

  executeChildAction(action: (sm: ChildStateMachine) => void) {
    action(this.practiceStateMachine)
  }

  executePracticeAction(action: (sm: PracticeStateMachine) => void) {
    action(this.practiceStateMachine)
  }
}
